import { render, staticRenderFns } from "./FacilityEditFormRelation.vue?vue&type=template&id=ac672502&"
import script from "./FacilityEditFormRelation.vue?vue&type=script&lang=js&"
export * from "./FacilityEditFormRelation.vue?vue&type=script&lang=js&"
import style0 from "./FacilityEditFormRelation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports